//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import PosterFormDialog from './PosterFormDialog'
import Posters from '@/api/promotores/posters.api'

export default {
  data() {
    return {
      selected: [],
      data: [],
      columns: [
        { name: "id", label: "Id", field: "id", sortable: true, style: "width: 10px" },
        {
          name: "nombre",
          label: "Nombre",
          field: "nombre",
          sortable: true,
          align: "left",
          classes: "bg-grey-2 ellipsis",
          headerClasses: "bg-primary text-white",
        },
        { name: "slug", label: "Slug", field: "slug", sortable: true, align: 'left' },
        { name: "descripcion", label: "Descripcion", field: "descripcion", align: "left", style: "width: 60%" },
        { name: "estado", label: "Estado", field: "deleted_at", format: this.formatDeletedAt },
      ],
      showPosterEdit: false,
      showPosterCreate: false,
      loading: false,
    }
  },

  computed: {
    hasSelected() {
      return this.selected.length > 0
    }
  },

  mounted() {
    this.loadPosters()
  },

  methods: {
    async loadPosters() {
      try {
        this.loading = true
        this.data = await Posters.all()
      } finally {
        this.loading = false
      }
    },
    openPosterDialog(poster = {}) {
      this.$q.dialog({
        component: PosterFormDialog,
        poster
      })
        .onOk((poster) => {
          this.loadPosters()
        })
    },
    async activar() {
      await Promise.all(
        this.selected.map(e => Posters.restore(e.slug))
      )
      this.loadPosters()
    },
    async desactivar() {
      await Promise.all(
        this.selected.map(e => Posters.delete(e.slug))
      )
      this.loadPosters()
    },
    formatDeletedAt(value) {
      return value === null ? 'Activo' : 'Desactivado'
    }
  },
}
